import React from 'react'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import { CardLayout, Text, useWindowSize } from '../../../../modules/Dashboard'
import FlashIcon from '../../../../components/icons/FlashIcon'
import RenderFastScans from './RenderFastScans'
import CurrentPlan from '../../../plans/components/CurrentUserPlan'

const FastScansMain = () => {
    const { width } = useWindowSize()

    return (
        <div className='grid grid-cols-3 gap-5 auto-rows-auto mx-auto'>
            <div className='col-span-3 flex flex-col gap-2'>
                <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <span className="flex items-center justify-center w-10 h-10 bg-[#9810FA33] rounded-lg">
                            <FlashIcon color="#C27AFF" />
                        </span>
                        <Text tid="fast-scan" className="text-xl !text-[#F3E8FF]" />
                    </div>

                    {/* Hide hint on mobile root automatically */}
                    <Text
                        tid="fast-scan-page-hint"
                        className="!text-[#DAB2FF]"
                    />
                </div>
            </div>
            <div className='col-span-3'>
                <CurrentPlan />
            </div>
            <div className='col-span-3'>
                <RenderFastScans />
            </div>
        </div>
    )
}

export default FastScansMain